"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowDateEdit_1 = require("../../../../../../shared/components/editors/CardRowDateEdit");
var CardRowTimeEdit_1 = require("../../../../../../shared/components/editors/CardRowTimeEdit");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonTextEditor_1 = require("../../../../../../shared/components/editors/CardRowButtonTextEditor");
var ParNewsEditor = /** @class */ (function (_super) {
    __extends(ParNewsEditor, _super);
    function ParNewsEditor(props) {
        return _super.call(this, props) || this;
    }
    ParNewsEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            this.setState({
                title: this.props.record.title,
                description: this.props.record.description,
                pprogram_id: this.props.record.pprogram_id,
                pprogram_title: this.props.record.pprogram_title,
                cms_image_url: this.props.record.cms_image_url,
                is_published: this.props.record.is_published,
                publish_year: this.props.record.post_year,
                publish_month: this.props.record.post_month,
                publish_day: this.props.record.post_day,
                publish_hour: this.props.record.post_hour,
                publish_minute: this.props.record.post_minute,
                publish_second: this.props.record.post_second,
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Редактирование новости"]);
            });
        }
        else {
            this.setState({
                title: "",
                description: "",
                pprogram_id: 0,
                pprogram_title: "",
                cms_image_url: "",
                is_published: false,
                publish_year: 2022,
                publish_month: 1,
                publish_day: 1,
                publish_hour: 0,
                publish_minute: 0,
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание новости"]);
            });
        }
        this.doReSetRules();
    };
    ParNewsEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            cms_image_url_rules: { isError: false },
            pprogram_rules: { isError: false },
        });
    };
    ParNewsEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                title: this.state.title,
                cms_image_url: this.state.cms_image_url,
                description: this.state.description,
                is_published: this.state.is_published,
                publish_year: this.state.publish_year,
                publish_month: this.state.publish_month,
                publish_day: this.state.publish_day,
                publish_hour: this.state.publish_hour,
                publish_minute: this.state.publish_minute,
                publish_second: this.state.publish_second,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Новость изменена!");
            });
        }
    };
    ParNewsEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        if ((!this.state.cms_image_url) || (this.state.cms_image_url.length === 0)) {
            this.setState({ cms_image_url_rules: { isError: true, errorMessage: "Поле [изображение] не заполнено!" } });
            return false;
        }
        if ((this.state.pprogram_id <= 0) || (this.state.pprogram_title.length === 0)) {
            this.setState({ pprogram_rules: { isError: true, errorMessage: "Поле [партнерская программа] не выбрано!" } });
            return false;
        }
        return true;
    };
    ParNewsEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                title: this.state.title,
                cms_image_url: this.state.cms_image_url,
                description: this.state.description,
                pprogram_id: this.state.pprogram_id,
                is_published: this.state.is_published,
                publish_year: this.state.publish_year,
                publish_month: this.state.publish_month,
                publish_day: this.state.publish_day,
                publish_hour: this.state.publish_hour,
                publish_minute: this.state.publish_minute,
                publish_second: this.state.publish_second
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Новость добавлена!");
            });
        }
    };
    ParNewsEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    ParNewsEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить новость";
        }
        else {
            return "Изменить новость";
        }
    };
    ParNewsEditor.prototype.DoShowSelectImageDialog = function () {
        var _this = this;
        this.props.dialogSelectImage.SetDialogTitle("Выбор изображения").SetOnSelect(function (brandIdentity, dirName, fileName) {
            _this.setState({ cms_image_url: brandIdentity + "/" + dirName + "/" + fileName }, function () {
                _this.props.dialogSelectImage.Close();
            });
        }).Show();
    };
    ParNewsEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 600 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "П.Программа:", placeholder: "Выберите партнерскую программу" }, value: { key: this.state.pprogram_id, value: this.state.pprogram_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        pprogram_id: newVal.key,
                        pprogram_title: newVal.value,
                        pprogram_rules: { isError: false },
                    });
                }, items: this.props.pprogramsList, disabled: this.props.record != null, required: true, rules: this.state.pprogram_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: {
                    caption: "Изображение:",
                    placeholder: "Выберите изображение",
                    buttonHint: "Выберите изображение"
                }, readonly: true, onButtonClick: this.DoShowSelectImageDialog.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        cms_image_url: newVal,
                        cms_image_url_rules: { isError: false }
                    });
                }, value: this.state.cms_image_url, buttonIcon: "search", required: true, rules: this.state.cms_image_url_rules }),
            React.createElement(CardRowDateEdit_1.default, { texts: { caption: "Дата публикации", placeholder: "Выберите дату" }, value: {
                    day: this.state.publish_day,
                    month: this.state.publish_month,
                    year: this.state.publish_year
                }, onValueChanged: function (year, month, day) {
                    _this.setState({
                        publish_day: day,
                        publish_month: month,
                        publish_year: year
                    });
                } }),
            React.createElement(CardRowTimeEdit_1.default, { texts: { caption: "Время публикации", placeholder: "Выберите время" }, value: {
                    hour: this.state.publish_hour,
                    minute: this.state.publish_minute,
                    second: this.state.publish_second
                }, onValueChanged: function (hour, minute, second) {
                    _this.setState({
                        publish_hour: hour,
                        publish_minute: minute,
                        publish_second: second
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal,
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Публикация доступна", value: this.state.is_published, onChecked: function (checked) { _this.setState({ is_published: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return ParNewsEditor;
}(React.Component));
exports.default = ParNewsEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_news/ui/component/ParNewsEditor.tsx
// module id = 2479
// module chunks = 0